/**
 * The two OHS lists that drive access (first_aid_user_roles.role). The only OHS permission
 * (caohsmanageedit) manages these lists - everything else comes from being on one.
 */
export const PEOPLE_ROLES = Object.freeze({
    firstAider: "first_aider",
    ohsRepresentative: "ohs_representative"
});

export const EVENT_TYPES = Object.freeze({
    firstAiderCheck: "first_aider_check",
    managerCheck: "manager_check",
    usage: "usage"
});

export const EVENT_TYPE_LABELS = Object.freeze({
    [EVENT_TYPES.firstAiderCheck]: "First Aider Check",
    [EVENT_TYPES.managerCheck]: "OHS Rep Check",
    [EVENT_TYPES.usage]: "Items Used (QR)"
});

export const CONDITION_LABELS = Object.freeze({
    ok: "OK",
    low: "Low",
    damaged: "Damaged",
    expired: "Expired",
    expiring_soon: "Expiring Soon",
    not_yet_checked: "Not Yet Checked"
});

// Matches the API's EXPIRING_SOON_DAYS - within this many days of its expiry date an item is Expiring Soon.
export const EXPIRING_SOON_DAYS = 30;

/**
 * The checker only chooses OK or Damaged per item - Low and Expired are worked out from the
 * quantity and expiry date, and an item can be several at once.
 */
export const ITEM_CONDITION_OPTIONS = ["ok", "damaged"].map((condition) => ({
    value: condition,
    label: CONDITION_LABELS[condition]
}));

// The Analytics "Expiring Soon" table looks further ahead than the status/restock list, for planning.
export const DEFAULT_EXPIRY_WINDOW_DAYS = 120;

export const PERFORM_CHECK_TOOLTIP =
    "Perform First Aider Check - the box's regular monthly check. It sets the box's condition and last-checked date.";
export const PERFORM_MANAGER_CHECK_TOOLTIP =
    "Perform OHS Rep Check - an independent spot-check to verify the first aider's report. It overrides the stock and condition the first aider recorded and is compared on the Discrepancies tab, but doesn't count as the monthly check.";

export const OHS_BASE_PATH = "/campusAdministration/ohs";

// Building checklist answers (ohs_building_check_answers.answer). Every question is worded so Yes is the safe answer.
export const BUILDING_CHECK_ANSWERS = Object.freeze({
    yes: "yes",
    no: "no",
    notApplicable: "na"
});

export const BUILDING_CHECK_ANSWER_LABELS = Object.freeze({
    [BUILDING_CHECK_ANSWERS.yes]: "Yes",
    [BUILDING_CHECK_ANSWERS.no]: "No",
    [BUILDING_CHECK_ANSWERS.notApplicable]: "N/A"
});

export const PERFORM_BUILDING_CHECK_TOOLTIP =
    "Perform Building Check - the building's monthly walk-through of the OHS checklist.";

export const REPORT_DATE_TIME_FORMAT = "D MMM YYYY, HH:mm";
